import React, { useEffect, useState } from "react";
import * as S from "./TabelaExtratosStyle";
import { goldenBoxService } from "../../../Services/goldenBoxService";
import { FaSpinner, FaSearch } from "react-icons/fa";
import ModalExtrato from "../ModalExtrato/ModalExtrato";

export default function TabelaExtratos() {
  const [extracts, setExtracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  // Debounce para a busca
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [selectedExtract, setSelectedExtract] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const limit = 10;

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchTerm);
      setPage(1); // Reseta para pagina 1 ao buscar
    }, 500);
    return () => clearTimeout(handler);
  }, [searchTerm]);

  const fetchExtracts = async () => {
    try {
      setLoading(true);
      const offset = (page - 1) * limit;
      const response = await goldenBoxService.getClientExtracts(
        debouncedSearch,
        limit,
        offset
      );
      setExtracts(response.data || []);
      setTotalCount(response.totalCount || 0);
    } catch (error) {
      console.error("Erro ao buscar extratos", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExtracts();
  }, [page, debouncedSearch]);

  const handleRowClick = (item) => {
    setSelectedExtract(item);
    setIsModalOpen(true);
  };

  const totalPages = Math.ceil(totalCount / limit);

  return (
    <>
      <S.Container>
        {/* HeaderControl fica fora do loading para a busca não sumir */}
        <S.HeaderControl>
          <S.SearchBar>
            <FaSearch />
            <input
              type="text"
              placeholder="Pesquisar por descrição..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </S.SearchBar>
        </S.HeaderControl>

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "60px",
              background: "#f9fafb",
              borderRadius: "8px",
            }}
          >
            <FaSpinner
              className="spinner"
              size={30}
              color="#D4AF37"
              style={{ animation: "spin 1s linear infinite" }}
            />
            <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
          </div>
        ) : extracts.length === 0 ? (
          <S.EmptyState>
            Nenhum registro encontrado para sua pesquisa.
          </S.EmptyState>
        ) : (
          <>
            <S.TableContainer>
              <S.Table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Data e Hora</th>
                    <th>Descrição</th>
                    <th>Caixinha ID</th>
                  </tr>
                </thead>
                <tbody>
                  {extracts.map((item) => (
                    <tr key={item.id} onClick={() => handleRowClick(item)}>
                      <td className="id-col">#{item.id}</td>
                      <td className="date">
                        {item.dateCreated
                          ? new Date(item.dateCreated).toLocaleString("pt-BR")
                          : "-"}
                      </td>
                      <td className="desc" title={item.description}>
                        {item.description}
                      </td>
                      <td className="box-id">
                        {item.goldenBoxId ? `#${item.goldenBoxId}` : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </S.Table>
            </S.TableContainer>

            {totalCount > limit && (
              <S.PaginationContainer>
                <span>
                  Página {page} de {totalPages}
                </span>
                <S.PageButton
                  disabled={page === 1}
                  onClick={() => setPage((p) => p - 1)}
                >
                  Anterior
                </S.PageButton>
                <S.PageButton
                  disabled={page === totalPages}
                  onClick={() => setPage((p) => p + 1)}
                >
                  Próxima
                </S.PageButton>
              </S.PaginationContainer>
            )}
          </>
        )}
      </S.Container>

      <ModalExtrato
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        data={selectedExtract}
      />
    </>
  );
}
